import { styled } from 'styled-components';
import { Typography } from '@altibox/design-system-component-lib';

import { spacing1, spacing2, spacing3, spacing4, spacing5 } from 'app/style/spacing';
import { breakpointTablet } from 'app/style/breakpoints';
import { colorSecondary200 } from 'app/style/colors';

export const StyledTotalPrices = styled.div`
    padding: ${spacing2} 0;
    border-bottom: 1px solid ${colorSecondary200};
    border-top: 1px solid ${colorSecondary200};
    margin-top: ${spacing3};

    @media (min-width: ${breakpointTablet}) {
        padding: ${spacing5} 0 0;
        border-bottom: 0;
        margin-top: ${spacing4};
    }
`;

export const StyledLabel = styled(Typography)`
    padding-right: ${spacing1};
    font-weight: normal;
`;

export const StyledValue = styled(Typography)`
    font-weight: normal;
`;

export const StyledTotalPriceRow = styled.div`
    padding-bottom: ${spacing1};
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    &:first-child {
        ${StyledLabel} {
            font-weight: bold;
        }

        ${StyledValue} {
            font-weight: bold;
        }
    }

    &:last-child {
        padding-bottom: 0;
    }

    @media (min-width: ${breakpointTablet}) {
        padding-bottom: ${spacing2};
    }
`;
